<template>
  <div class="flex-box vertical address-book">
    <a-tree
      class="flex-grow"
      v-model="keys"
      :expanded-keys="expandKeys"
      :checkable="checkable"
      :selectable="selectable"
      :tree-data="list"
      @expand="handleExpand"
      @select="handleSelect"
    />
  </div>
</template>

<script>
import { getCheckedItems } from "../common/constant/process";

export default {
  name: "address-book",
  props: {
    selectable: {
      type: Boolean,
      default: true,
    },
    orgList: Array,
    checkable: Boolean,
    checkedKeys: Object,
  },
  data() {
    return {
      keys: [],
      list: [],
      expandKeys: [],
      groupList: null,
    };
  },
  watch: {
    checkedKeys(val) {
      if (val && this.keys.length <= 0) {
        let keys = getCheckedItems(this.groupList, val);
        this.keys = keys;
      }
    },
  },
  created() {
    if (this.orgList) {
      this.dealList(this.orgList);
    } else {
      this.getList();
    }
  },
  methods: {
    getList() {
      this.$axios("/admin/get-list-new").then((res) => {
        this.dealList(res);
      });
    },
    dealDeptList(list, fkey) {
      return list
        .map((dept) => {
          const admin_list = dept.admin_list || [];
          const dept_list = dept.dept_list || [];
          const key = `${fkey}_dept-${dept.id}`;
          return {
            key,
            title: dept.name,
            order: dept.order,
            isDept: true, // 部门节点
            children: [...this.dealDeptList(dept_list, key), ...this.dealAdminList(admin_list, key)],
          };
        })
        .sort((a, b) => a.order - b.order);
    },
    dealAdminList(list, fkey) {
      return list
        .map((item) => {
          return {
            key: `${fkey}_admin-${item.id}`,
            title: item.name,
            order: item.order,
            isAdmin: true, // 人员节点
          };
        })
        .sort((a, b) => a.order - b.order);
    },
    dealTreeList(list) {
      return list.map((node) => {
        const id = node.id;
        const admin_list = node.admin_list || [];
        const dept_list = node.dept_list || [];
        const key = `parent-${id}`;
        return {
          key,
          title: node.name,
          isParent: true, // 顶层节点
          isPosition: !!node.position_id, // 统战阵地节点
          children: [...this.dealDeptList(dept_list, key), ...this.dealAdminList(admin_list, key)],
        };
      });
    },
    getExpandKeys(list, expandKeys = []) {
      list?.forEach((item) => {
        if (item.isParent || item.isDept) {
          expandKeys.push(item.key);
          const children = item.children || [];
          if (children.length) {
            this.getExpandKeys(children, expandKeys);
          }
        }
      });
      // console.log("expandKeys:", expandKeys);
      return expandKeys;
    },
    dealList(res) {
      const treeList = this.dealTreeList(res);
      // console.log("treeList:", treeList);
      if (this.checkable) {
        this.list = treeList;
        this.groupList = res;
        this.expandKeys = this.getExpandKeys(treeList);
        if (this.checkedKeys) {
          let keys = getCheckedItems(res, this.checkedKeys);
          this.keys = keys;
        }
      } else {
        this.list = treeList;
        this.groupList = res;
        this.expandKeys = [treeList[0].key];
      }
      this.$emit("org", res);
    },
    // flag true返回item false返回key
    getCheckedItems(list, keys, flag) {
      list = list || this.groupList;
      keys = keys || this.checkedKeys;
      if (!list || keys) return [];
      let res = [];
      let { dept, admin } = this.checkedKeys;
      if (dept) {
        dept.forEach((d) => {
          let item = list.find((o) => o.id == d);
          if (item) {
            if (flag) {
              res.push(item);
            } else {
              res.push(`0_${item.id}`);
            }
          }
        });
      }
      if (admin) {
        let personList = list.reduce((acc, item) => (item.admin_list ? acc.concat(item.admin_list) : acc), []);
        admin.forEach((a) => {
          let item = personList.find((o) => o.id == a);
          if (item && dept.indexOf(item.id) < 0) {
            if (flag) {
              res.push(item);
            } else {
              res.push(`0_${item.dept}_${item.id}`);
            }
          }
        });
      }
      return res;
    },
    getCheckedList() {
      let keys = this.keys.map((key) => key.split("_"));
      keys.sort((a, b) => {
        return a.length - b.length;
      });
      let dept = [],
        admin = [],
        items = [];
      // list = this.groupList;
      keys.forEach((item) => {
        const node = this.getItemByIds(item);
        this.getItemType(item, node);
        if (node.isParent || node.isDept) {
          dept.push(node.id);
          items.push(node);
        } else if (node.isAdmin) {
          if (!dept.includes(node.dept)) {
            admin.push(node.id);
            items.push(node);
          }
        }
      });
      return { dept, admin, items };
    },
    handleExpand(keys) {
      this.expandKeys = keys;
    },
    getItemByIds(ids) {
      let list = null; // 节点列表
      let node = null; // 当前节点
      let parentName = ""; // 父级部门名称
      for (let i = 0; i < ids.length; i++) {
        const [type, id] = ids[i].split("-");
        if (node) {
          parentName = node.name;
          // 判断当前节点类型
          if (type == "admin") {
            list = node.admin_list;
          } else {
            list = node.dept_list;
          }
        } else {
          list = this.groupList;
        }
        node = list.find((n) => n.id == id);
      }
      node.deptName = parentName;
      node.key = ids.join("_");
      node.flagKey = ids[ids.length - 1];
      return node;
    },
    getItemType(ids, item) {
      if (item.nodeType) return;
      const lastId = ids[ids.length - 1];
      const [type] = lastId.split("-");
      item.nodeType = type;
      switch (type) {
        case "parent":
          item.isParent = true;
          if (item.position_id) {
            item.isPosition = true;
          }
          break;
        case "dept":
          item.isDept = true;
          break;
        case "admin":
          item.isAdmin = true;
          break;
      }
    },
    handleSelect(keys) {
      let key = keys[0];
      // console.log("handleSelect keys:", keys, key);
      if (key) {
        let temp = key.split("_");
        const item = this.getItemByIds(temp);
        this.getItemType(temp, item);
        // console.log("handleSelect:", temp, item);
        this.$emit("select", { ids: temp, item });
      } else {
        this.$emit("select", { ids: [], item: null });
      }
    },
  },
};
</script>

<style scoped lang="less">
.add-dept {
  justify-content: center;
  height: 36px;
  cursor: pointer;
}
.select-item {
}
</style>
